import React, { FC } from 'react';
import { Seo, useSeoDefaults } from '@funtech-int/yango-shared';

import { QueryParameter } from '@/shared/constants/queryParams';
import { channelsRoute } from '@/scenarios/channels/routes';
import { useI18n } from '@/shared/i18n/seo/useI18n';
import { useSearchParams } from '@/shared/hooks/useSearchParams';

export const ChannelsPageHead: FC = () => {
    const searchParams = useSearchParams();
    const openedChannelId = searchParams.get(QueryParameter.OPENED_CHANNEL_ID);
    const intl = useI18n();
    const { seoSiteName } = useSeoDefaults();

    const title = intl('channels_seo_title', { brandName: seoSiteName });
    const description = intl('channels_meta_description', { brandName: seoSiteName });

    const location = channelsRoute();

    return (
        <>
            <Seo.BasicMeta
                seoTitle={title}
                seoDescription={description}
                location={location}
                queryParams={openedChannelId ? { openedChannelId } : {}}
            />
            <Seo.OgWebsiteMeta
                ogTitle={title}
                ogDescription={description}
                location={location}
                queryParams={openedChannelId ? { openedChannelId } : {}}
            />
            <Seo.TwitterMeta twitterDescription={description} />
        </>
    );
};
